const productThumbs = new Swiper('#productThumbs', {
    loop: true,
    slidesPerView: 5,
    spaceBetween: 12,
    freeMode: true,
    threshold: 10,
    watchSlidesProgress: true,
    //preventInteractionOnTransition: true,
    navigation: {
        nextEl: '.thumbs-button-next',
        prevEl: '.thumbs-button-prev',
    },
    mousewheel: true,
    keyboard: true,
    on: {
        afterInit: function () {
            /* swiper 8 */
            console.log('this.dataset.slides', this.$el[0].dataset.slides)
            if (this.$el[0].dataset.slides > 5) return;
            this.params.slidesPerView = this.$el[0].dataset.slides;
            /* swiper 10 */
            //console.log('this.dataset.slides', this.el.dataset.slides)
            /*if (this.el.dataset.slides > 5) return;
            this.params.slidesPerView = this.el.dataset.slides;*/
            //this.params.watchSlidesProgress = false;
        },
    }
});
//console.log('productThumbs', productThumbs)
/*console.log(window.innerWidth);
if (window.innerWidth > 749) {
    productThumbs.init();
}*/
//window.addEventListener("resize", manageSliders);
/*function manageSliders() {
    if (window.innerWidth > 749) {
        productThumbs.init();
        productThumbs.enable();
    } else {
        productThumbs.disabled();
    }
}*/
window.theme.productThumbs = productThumbs;


const productSwiper = new Swiper('#productSlider', {
    loop: true,
    //speed: 500,
    //autoplay: true,
    //effect: "fade",
    //fadeEffect: { crossFade: false },
    spaceBetween: 10,
    //grabCursor: true,
    threshold: 10,
    //zoom: true,
    //preventInteractionOnTransition: true,
    thumbs: {
        swiper: productThumbs,
    },
    pagination: {
        el: '.swiper-pagination.product-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.product-navigation-next',
        prevEl: '.product-navigation-prev',
    }
});
window.theme.productSwiper = productSwiper;
productSwiper.on('click', function () {
    console.log('CLICK')
    let currentSlide = productSwiper.slides[productSwiper.clickedIndex];
    console.log('currentSlide', currentSlide);
    if (currentSlide.dataset.type === 'image') return;
    console.log('IS VIDEO');
    let videoSlide = currentSlide.querySelector('video');
    let videoPlay = currentSlide.querySelector('.video-play__wrapper');
    videoPlay.style = "display:none;"
    console.log('IS VIDEO', videoSlide);
    videoSlide.play();
    videoSlide.addEventListener("ended", (event) => {
        console.log("Video ended");
        setTimeout(() => {
            videoSlide.pause();
            videoSlide.currentTime = 0;
            videoSlide.load();
            videoPlay.style = "display:flex;"
        }, "3000");
    });
});

